import { useDispatch, useSelector } from 'react-redux';
import BannersService from '../../services/Banners/BannersService';
import { setActiveBanners } from '../../stores/BannersStore';
import { RootState } from '../../stores/Store';

/**
 * Handles the banners that should currently be displayed to end users across the portal
 */
function useActiveBanners() {
  const dispatch = useDispatch();
  const activeBanners = useSelector((state: RootState) => state.bannersReducer.activeBanners);

  /**
   * Fetches the currently active banners for the logged-in user.
   */
  const fetchActiveBanners = () => {
    BannersService.api.fetchActiveBanners().then(
      (response) => {
        dispatch(
          setActiveBanners(
            response.data.banners.map((banner) => ({
              id: banner.id,
              status: banner.status,
              createdBy: banner.createdBy ?? '',
              bannerType: banner.bannerType,
              scope: banner.scopeType,
              selectedMarkets: banner.marketIds ?? [],
              selectedCompanies: banner.companyIds ?? [],
              bannerTitle: banner.title,
              timezone: '',
              startDate: banner.startAt,
              endDate: banner.endAt,
              maintenanceTimezone: '',
              maintenanceStart: banner.maintenanceWindow?.startAt ?? '',
              maintenanceEnd: banner.maintenanceWindow?.endAt ?? '',
              messages: banner.translations ?? {},
              dismissible: banner.dismissible,
            })),
          ),
        );
      },
      () => {
        dispatch(setActiveBanners([]));
      },
    );
  };

  return { activeBanners, fetchActiveBanners };
}

export default useActiveBanners;
